import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const usersDesignationServices = {
  getUserDesignationData,
  addNewUserDesignation,
  updateUserDesignationData,
  softDeleteRestoreUserDesignation,
  deleteUserDesignationData
};

// Add New Designation
async function addNewUserDesignation(userData) {
  const response = await fetch(
    `${config.API_URL}addNewUserDesignation`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data;
}

// Update Designation
async function updateUserDesignationData(userData) {
  const response = await fetch(
    `${config.API_URL}updateUserDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Soft Delete & Restore Designation
async function softDeleteRestoreUserDesignation(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreUserDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Delete Designation
async function deleteUserDesignationData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteUserDesignationData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Get Designation
async function getUserDesignationData(status, category, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getUserDesignationData/${status}/${category}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getUserDesignationData/${status}/${category}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}